import { trpc } from "@api/client";

export const useAnswerQuestion = () => {
  const { mutateAsync, isLoading, error } = trpc.answerQuestion.useMutation();
  return { answerQuestion: mutateAsync, isLoading, error };
};
